import script from "./Save_User.vue?vue&type=script&setup=true&lang=js"
export * from "./Save_User.vue?vue&type=script&setup=true&lang=js"

import "./Save_User.vue?vue&type=style&index=0&id=2854f2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2854f2be"]])

export default __exports__